/**
 * Пользователь кликнул на кнопку "Не сейчас"
 *
 * @type {string}
 */
export const USER_REJECT_MOBILE_DOWNLOAD_POPUP = 'USER_REJECT_MOBILE_DOWNLOAD_MODAL';

/**
 * Пользователь кликнул на кнопку "Установить"
 *
 * @type {string}
 */
export const USER_ACCEPT_MOBILE_DOWNLOAD_POPUP = 'USER_ACCEPT_MOBILE_DOWNLOAD_MODAL';

/**
 * Инициализация
 *
 * @type {string}
 */
export const INITIAL_MOBILE_POPUP = 'INITIAL_MOBILE_POPUP';
